import type React from 'react';
import ReportProblemRoundedIcon from '@mui/icons-material/ReportProblemRounded';
import Typography from '@mui/material/Typography';
import { FlexColumn } from 'src/components/Atoms/FlexBox';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
interface ErrorFallbackProps {
  error: Error;
  resetErrorBoundary: () => void;
}
interface ErrorSource {
  file: string;
  line: string;
  column: string;
  hash: string;
}
const ErrorFallback: React.FC<ErrorFallbackProps> = ({
  error,
  resetErrorBoundary
}) => {
  let source: ErrorSource | null = null;
  try {
    const fileStr = error.stack?.split('\n')[1]?.replace(/^\s+at\s+/, '');
    if (fileStr) {
      const file = new URL(fileStr);
      const t = file.searchParams.get('t') || '';
      const [hash, line, column] = t.split(':');
      source = {
        file: file.pathname,
        line: line || '',
        column: column || '',
        hash: hash || ''
      };
    }
  } catch (e) {
    console.error('Error parsing error stack:', e);
  }
  return <FlexColumn component={Paper} elevation={3} sx={{
    p: 4,
    textAlign: 'center',
    bgcolor: '#AEAEAE',
    color: 'white',
    borderRadius: 2,
    maxWidth: 400,
    margin: 'auto',
    mt: 6
  }}>
      <ReportProblemRoundedIcon sx={{
      fontSize: 48,
      color: '#f44336',
      mb: 2
    }} />
      <Typography variant='h6' gutterBottom>
        Something went wrong
      </Typography>
      <Typography variant='body2' sx={{
      mb: 3
    }}>
        {error.message || 'An unexpected error occurred.'}
      </Typography>
      {source && <Typography variant='caption' sx={{
      mb: 3
    }}>
          <strong>File:</strong>
          {' '}
          {source.file}
          <br />
          <strong>Line:</strong>
          {' '}
          {source.line}
          <br />
          <strong>Column:</strong>
          {' '}
          {source.column}
          <br />
        </Typography>}
      <Button variant='contained' color='primary' onClick={resetErrorBoundary} sx={{
      mt: 2
    }}>
        Try Again
      </Button>
    </FlexColumn>;
};
export default ErrorFallback;